import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CircularProgress,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

//  loading
import RestartAltIcon from "@mui/icons-material/RestartAlt";

// icons
import { ChevronLeft } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment-jalaali";
import { GradientBorderBox } from "../../../../../../Components";
export default function Transaction({ transActions }) {
  const theme = useTheme();
  const rowItems = transActions?.map((e, index) => {
    return (
      <Stack
        key={index}
        direction={"row"}
        sx={{
          bgcolor: theme.palette.background.paper,
          py: ".7rem",
          color: theme.palette.primary.main,
          borderRadius: "6px",
          direction: "rtl",
          width: "100%",
        }}
      >
        <Typography sx={{ textAlign: "center", width: "20%" }}>
          {moment.unix(e?.created_at).format("jYYYY/jMM/jDD")}
        </Typography>
        <Typography sx={{ textAlign: "center", width: "20%" }}>
          {moment.unix(e?.created_at).format("HH:mm")}
        </Typography>
        <Typography sx={{ textAlign: "center", width: "20%" }}>
          {Number(e?.payment_details?.final_amount)?.toLocaleString()}
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            width: "40%",
            fontSize: { xs: ".7rem", sm: ".8rem", md: "1rem" },
            color: theme.palette.primary.main,
            fontWeight: "bold",
          }}
        >
          رسید دیجیتال : {e?.payment_details?.sale_reference_id}
        </Typography>
      </Stack>
    );
  });
  return (
    <Stack gap={"1rem"} mt={".7rem"}>
      {/* Header */}
      <Stack
        direction={"row"}
        sx={{
          // borderRadius: "8px",
          py: "1rem",
          bgcolor: theme.palette.background.default,
          position:"relative",
          justifyContent: "space-between",
          direction: "rtl",
          zIndex:"10" ,
          display: rowItems?.length > 0 ? "flex" : "none",
          borderRadius:".5rem"
        }}
      >
        <Typography sx={{ textAlign: "center", width: "20%" }}>
          تاریخ
        </Typography>
        <Typography sx={{ textAlign: "center", width: "20%" }}>ساعت</Typography>
        <Typography sx={{ textAlign: "center", width: "20%" }}>مبلغ</Typography>
        <Typography sx={{ textAlign: "center", width: "40%" }}>
          توضیحات
        </Typography>
        <GradientBorderBox radius=".5rem" />
      </Stack>

      {/* Rows */}
      <Stack direction={"column"} gap={".7rem"}>
        {rowItems?.length > 0 ? (
          rowItems
        ) : (
          <Stack
            sx={{
              color: theme.palette.primary.main,
              justifyContent: "center",
              fontSize: "1.2rem",
              alignItems: "center",
              height: "400px",
              width: "100%",
            }}
          >
            هنوز تراکنشی ثبت نشده است
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
